var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06205 0.75C5.7514 0.75 5.49955 1.00184 5.49955 1.3125C5.49955 1.62316 5.7514 1.875 6.06205 1.875L11.8139 1.875L0.414045 13.2749C0.19011 13.4987 0.19011 13.8618 0.414045 14.0858C0.637973 14.3097 1.00104 14.3097 1.22497 14.0858L12.6245 2.68619V8.4375C12.6245 8.74815 12.8764 9 13.187 9C13.4977 9 13.7495 8.74815 13.7495 8.4375V1.3125C13.7495 1.00184 13.4977 0.75 13.187 0.75L6.06205 0.75Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpIcon);
export default __webpack_public_path__ + "static/media/follow_up_icon.271798f7359af346ed218a0ced928792.svg";
export { ForwardRef as ReactComponent };